import { auditFormService } from '#apps/client-web/features/audit-form/services/audit-form';
import { fileStorageService } from '#apps/client-web/features/file-storage/services/file-storage';
import { ReactQueryClientService } from '#apps/client-web/app/services/react-query-client';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { FormPageLayout } from '#apps/client-web/app/components/form-page-layout';

import { CenteredLayout } from '#packages/web/foundations/layouts/centered-layout';

import { AuditFormLightingTypeEntryPageMenu } from './audit-form-lighting-type-entry-page-menu';
import { AuditFormLightingTypeEntryPageContainer } from './audit-form-lighting-type-entry-page.container';
import { useAuditFormLightingTypeEntryPageViewModel } from './audit-form-lighting-type-entry-page.view-model';

export const AuditFormLightingTypeEntryPage = () => {
  const logger = useLogger('pages/audit-form-lighting-type-entry');

  const viewModel = useAuditFormLightingTypeEntryPageViewModel({
    auditFormService,
    fileStorageService,
    queryClient: ReactQueryClientService.offlineQueryClient,
    logger,
  });

  const { mainMenu, isDeleteDisabled, onDelete } = viewModel;

  return (
    <FormPageLayout
      title="Lighting Type"
      isFormChanged={viewModel.form.formState.isDirty}
      onSubmit={viewModel.onSubmit}
      isSubmitDisabled={viewModel.updateMutationState.state === 'pending'}
      headerChildren={
        viewModel.loadAuditFormState.state === 'success' && (
          <AuditFormLightingTypeEntryPageMenu
            onClose={mainMenu.close}
            onOpen={mainMenu.open}
            isOpen={mainMenu.isOpen}
            anchorEl={mainMenu.anchorEl}
            onDelete={onDelete.bind(null, { confirmed: false })}
            isDeleteDisabled={isDeleteDisabled}
          />
        )
      }>
      <CenteredLayout horizontal>
        <AuditFormLightingTypeEntryPageContainer viewModel={viewModel} />
      </CenteredLayout>
    </FormPageLayout>
  );
};
